import { Button, CloseButton, IconButton } from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  closePopup,
  openPopup,
} from '../../../../data/providers/popupsProvider';
import { Column } from '../../../layout/Column';
import { Row } from '../../../layout/Row';
import { CardBody } from '../../../shared/card/CardBody';
import { CardFooter } from '../../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../../shared/card/CardHeader';
import { PopupCard, PopupCardContent } from '../../../shared/popups/PopupCard';

interface IProps {
  onClose: () => void;
}

export const TsaDescription = (props: IProps): React.ReactElement => {
  return (
    <PopupCard onClose={props.onClose} size='small' noClickOutside>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h5>Total Score of Athleticism</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          <Column style={{ height: '100%', padding: '20px' }}>
            <Row>
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '1.1em',
                }}
              >
                The Total Score of Athleticism (TSA) value is derived by adding
                up the z-score values (ranges 0-100 or -4 to 4) for each of the
                metrics you select in "Settings". If you select 3 metrics for
                this report, the system will add up each individual score,
                divide by the number of metrics (in this case 3) and give you
                one composite score (i.e. TSA). You can select 3-7 metrics for
                this report option, of which can be from one test type or
                multiple test types (i.e. CMJ, IMTP). The TSA value is a way to
                profile athletes of a select population with the tests and
                metrics you value as a coach or organization. When selecting
                tests and metrics for this report, consider the qualities of the
                sport and position to guide your selection process. Learn more
                about the TSA value{' '}
                <a
                  target='_blank'
                  rel='noreferrer'
                  style={{ textDecoration: 'underline' }}
                  href='https://f.hubspotusercontent10.net/hubfs/5212164/UKSCA_TSA%20(1).pdf'
                >
                  here.
                </a>
              </div>
            </Row>
          </Column>
        </CardBody>
        <CardFooter surface={8}></CardFooter>
      </PopupCardContent>
    </PopupCard>
  );
};

export const TsaExplainer = withRouter(
  (props: RouteComponentProps): React.ReactElement => {
    const openDescription = (e: React.MouseEvent<HTMLElement>): void => {
      e.preventDefault();
      e.stopPropagation();
      openPopup(
        <TsaDescription onClose={closePopup(props.history)} />,
        props.history,
        'tsa-description'
      );
    };
    return (
      <InfoContainer>
        <IconButton
          onClick={openDescription}
          icon='info'
          title='More Info on TSA'
        />
      </InfoContainer>
    );
  }
);

const InfoContainer = styled.div`
  margin-left: 10px;
`;
